import React, { useState } from 'react';
import { Checkboard, ColorPicker, InfoTooltip, Popper, useMediaQueryContext, withFormikSupport, } from '@fourthwall/components';
import * as S from './ColorSelection.styled';
const ColorSelectionComponent = ({ label, value, info, onChange, onBlur }) => {
    const media = useMediaQueryContext();
    const [isOpen, setOpen] = useState(false);
    const handleBlur = () => {
        if (isOpen && onBlur && value) {
            onBlur({ color: value, isVariableUpdated: false });
        }
    };
    const toggleOpen = () => {
        handleBlur();
        setOpen((prevIsOpen) => {
            return !prevIsOpen;
        });
    };
    const handleChange = (color) => {
        if (onChange) {
            onChange(color);
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(Popper, { isOpen: isOpen, referenceComponent: React.createElement(S.PreviewContainer, { "data-testid": "ColorSelection.PreviewContainer", onClick: toggleOpen },
                React.createElement(Checkboard, null),
                React.createElement(S.Preview, { style: { backgroundColor: value }, "$withBorder": true, "data-testid": "ColorSelection.Preview" })), popperProps: {
                placement: 'bottom-start',
            }, style: media.tablet ? { paddingTop: 12 } : undefined, onClose: () => {
                handleBlur();
                setOpen(false);
            } },
            React.createElement(ColorPicker, { color: value || '#000000', format: "HEX", hexVisible: true, onValueChange: handleChange })),
        React.createElement("div", null,
            React.createElement(S.Label, null,
                label,
                React.createElement(InfoTooltip, { content: info })),
            React.createElement(S.Value, null, value))));
};
export const ColorSelection = withFormikSupport(ColorSelectionComponent);
